import DebitCardTransactionHistory from './DebitCardTransactionHistory';

export default DebitCardTransactionHistory;
